module.exports = __webpack_public_path__ + "img/exam_jan_2025_7q8ge67m.02d0eab8.jpg";